import { tsUtils } from '@neo-one/ts-utils';
import { Types } from '../../../constants';
import { BuiltinInstanceMemberCall } from '../../BuiltinInstanceMemberCall';
export class ArrayStorageIterator extends BuiltinInstanceMemberCall {
    canCall() {
        return true;
    }
    emitCall(sb, func, node, options, visited) {
        if (!options.pushValue) {
            if (visited) {
                sb.emitOp(node, 'DROP');
            }
            return;
        }
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        sb.emitHelper(node, options, sb.helpers.createValIterableIteratorStructuredStorage({ type: Types.ArrayStorage }));
    }
}

//# sourceMappingURL=iterator.js.map
